import EventUpdateDelete from '@/screens/EventUpdateDelete';

export default function Route() {
  return <EventUpdateDelete />;
}
